// assets/motive-search-off-native.js
(() => {
  // Chiude SOLO il dialog della ricerca nativa (non tocca carrello o altri dialog)
  const killNativeSearchModal = () => {
    document.querySelectorAll('dialog.search-modal__content[open]')
      .forEach(d => {
        try { d.close?.(); } catch (e) {}
        d.removeAttribute('open');
        d.style.display = 'none';
      });
    // rimuovi eventuali side-effect dello scroll lock solo se il dialog ricerca era aperto
    // (non tocchiamo lo state del carrello)
    // NB: se il tema usa una classe diversa per il lock della ricerca, aggiungila qui
  };

  // Intercetta SOLO i click sul trigger della ricerca dell’header
  const clickHandler = (e) => {
    // selettori più specifici per la ricerca (non più l'attributo generico on:click)
    const searchTrigger = e.target.closest(
      '.search-action,' +                                  // classica icona lente del tema
      '[data-action="open-predictive-search"],' +          // alcuni temi
      'button[aria-label*="cerca" i],' +                   // aria-label in IT
      'button[aria-label*="search" i]'                     // aria-label in EN
    );

    if (!searchTrigger) return;

    // SOLO se è il trigger della ricerca blocchiamo il default
    e.preventDefault();
    e.stopImmediatePropagation?.();

    // Spegni subito il modale nativo della ricerca se fosse aperto
    killNativeSearchModal();

    // Apri Motive
    if (window.MotiveSearch?.open) {
      window.MotiveSearch.open();
    }
  };

  // Cattura i click molto presto, prima dei listener del tema
  document.addEventListener('click', clickHandler, true);

  // Se per qualsiasi motivo il dialog di ricerca nativo appare, richiudilo all’istante
  const mo = new MutationObserver(() => {
    const openSearchDialog = document.querySelector('dialog.search-modal__content[open]');
    if (openSearchDialog) killNativeSearchModal();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // (Opzionale) scorciatoia "/" → lascia a Motive e chiudi l’eventuale modale ricerca nativo
  document.addEventListener('keydown', (e) => {
    if (e.key === '/' && !e.metaKey && !e.ctrlKey && !e.altKey) {
      setTimeout(killNativeSearchModal, 0);
    }
  });
})();
